import {
  DialogTrigger,
  LinkButton,
  Popover,
  PopoverContent,
} from "@certn/cascadia-react";
import { Trans } from "react-i18next";

export function WebhookSignatureWhatsThis() {
  return (
    <DialogTrigger>
      <LinkButton testID="" textStyle="form/body-secondary-link">
        <Trans>What's this?</Trans>
      </LinkButton>
      <Popover placement="top right">
        <PopoverContent>
          <Trans>
            Your Lever webhook enables Certn to send information to your Lever
            account. You can find your Webhooks in Lever by navigating to:
            <br />
            <br />
            Settings → Integrations and API → Webhooks
            <br />
            <br />
            Under 'Candidate Stage Change,' click "+ Add webhook" and copy the
            signature token
          </Trans>
        </PopoverContent>
      </Popover>
    </DialogTrigger>
  );
}
